import { ajax } from "@/assets/js/ajax";

export function getAccountList(data) {
  //账户列表
  return ajax({
    url: "cause/property/list",
    type: "get",
    data: data,
  });
}

export function AddAccount(data) {
  //账户添加
  return ajax({
    url: "cause/property/account/add",
    type: "post",
    data: data,
  });
}

export function EditAccount(data) {
  //账户修改
  return ajax({
    url: "cause/property/account/edit",
    type: "post",
    data: data,
    contentType: "application/json",
  });
}

export function DelAccount(data) {
  //账户删除
  return ajax({
    url: "cause/property/account/del",
    type: "post",
    data: data,
  });
}

export function AddHouse(data) {
  //房产添加
  return ajax({
    url: "cause/property/house/add",
    type: "post",
    data: data,
  });
}

export function EditHouse(data) {
  //房产修改
  return ajax({
    url: "cause/property/house/edit",
    type: "post",
    data: data,
    contentType: "application/json",
  });
}

export function DelHouse(data) {
  //房产删除
  return ajax({
    url: "cause/property/house/del",
    type: "post",
    data: data,
  });
}
